import { render, staticRenderFns } from "./BalanceMoneyInsight.vue?vue&type=template&id=2d85c197&scoped=true"
import script from "./BalanceMoneyInsight.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyInsight.vue?vue&type=script&lang=js"
import style0 from "./BalanceMoneyInsight.vue?vue&type=style&index=0&id=2d85c197&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d85c197",
  null
  
)

export default component.exports